export function display_upload() {
  function display_filename(input) {
    // this fixes the bug where the last uploaded file inside the edit profile form would show on the DOM at all times
    if ($('.tab-content .form-row input[name="picture"]').length > 0) {
      let $parent = $('.tab-content .form-row input[name="picture"]').closest('.form-row');
      let $input = $parent.find('input[type="file"]');

      if ($input[0].files.length <= 0) {
        $parent.find('.filename').html('');
      }
    }

    if (input.files && input.files[0]) {
      var file = input.files[0];
      var label = $("label[for='"+$(input).attr('id')+"'].button");
      label.siblings('.filename').html(file.name);
    }
  }

  $('body').on('change', "input[type='file']", function() {
    display_filename(this);
  });

  $('body').on("click", ".invisible-button", function() {
    $(this).siblings('label').trigger('click');
  });
}
